import React, { useState, useCallback } from 'react';
import { apiString as api } from '../utils/constants';
import axios from 'axios';

const ChpContext = React.createContext<any>(null);

export const ChpProvider = ({ children }: { children: React.ReactNode }) => {
    const [states, setStates] = useState<any[]>([]);
    const [cities, setCities] = useState<any[]>([]);
    const [citiesByKeyword, setCitiesByKeyword] = useState<any[]>([]);
    const [currentStep, setCurrentStep] = useState<string>('');

    const getCitiesByKeyword = async (keyword: string) => {
        const response = await axios.get(`${api}/common/getcitiesbykeyword?keyword=${keyword}`);
        setCitiesByKeyword(response.data);
    };

    const getCities = async () => {
        const response = await axios.get(`${api}/common/getallcity`);
        setCities(response.data);
    };

    const getStates = async () => {
        const response = await axios.get(`${api}/common/getallstate`);
        setStates(response.data);
    };

    const handleNextStep = useCallback(
        (steps: string[]) => {
            let stepIndex = steps.indexOf(currentStep);
            stepIndex = stepIndex + 1;
            let stepInfo = steps[stepIndex];
            setCurrentStep(stepInfo);
        },
        [currentStep]
    );

    const handlePreviousStep = useCallback(
        (steps: string[]) => {
            let stepIndex = steps.indexOf(currentStep);
            stepIndex = stepIndex - 1;
            let stepInfo = steps[stepIndex];
            setCurrentStep(stepInfo);
        },
        [currentStep]
    );

    const value = {
        states,
        getStates,
        citiesByKeyword,
        getCitiesByKeyword,
        setCitiesByKeyword,
        cities,
        getCities,
        setCities,
        currentStep,
        setCurrentStep,
        handleNextStep,
        handlePreviousStep,
    };

    return <ChpContext.Provider value={value}>{children}</ChpContext.Provider>;
};

export const useChpContext = () => React.useContext(ChpContext);

